export default "__VITE_ASSET__DkjgAEwx__"